import React, {Component} from 'react';
import request from 'superagent';
import {Alert} from "react-bootstrap";

import Constant from "../../commons/Constants";
import {openNotification, NotificationType, getUrl} from "../../commons/CommonUtils";

import UserListTable from "./UserListTable";
import UserDetail from "./UserDetailInfo";

class UserListView extends Component {

    constructor(props) {
        super(props);
        this.state = {
            status: Constant.STATUS.init,
            isShowUserDetail: false,
            userList: [],
            containerHeight: 2000,
            selectedUserId: ""
        }
    }

    componentDidMount() {
        this.initDataList();
    }

    initDataList = () => {
        this.getUserList();
    }

    getUserList = () => {
        this.setState({status: Constant.STATUS.trying, userList: []});
        const url = getUrl(Constant.Service.localUser, "/users");
        //'/api/users'
        return request.get(url).withCredentials().then((response) => {
            this.setState({userList: response.body, status: Constant.STATUS.done});
        }).then(() => {
            const height = document.getElementById('container').clientHeight - 110;
            this.setState({containerHeight: height});
        }).catch(err => {
            console.error(err);
            this.setState({
                    status: Constant.STATUS.error,
                    message: ("Failed to find the users. Cause by: " + err.message)
                },
                () => {
                    openNotification("Failed to find the users. Cause by: " + err.message, NotificationType.error);
                });
        });
    }

    openDetailPage = (userID) => {
        this.setState({isShowUserDetail: true, selectedUserId: userID}, () => {
            this.userDetailPanel.open(userID);
        });
    }

    closeDetailPage = (refresh) => {
        this.setState({isShowUserDetail: false, selectedUserId: ""});
        if (refresh) {
            this.initDataList();
        }
    }

    render() {
        const {userList, isShowUserDetail, status, message, containerHeight, selectedUserId} = this.state;

        return (
            <div className="page-container">
                <div id="container" className={`${isShowUserDetail ? 'col-md-5': 'col-md-12'} list`}>
                    <h2 className="page-title">User Management</h2>

                    {(status === Constant.STATUS.error && !isShowUserDetail) &&
                    <div>
                        <Alert bsStyle={status === Constant.STATUS.error ? "danger" : "info"}>
                            {message}
                        </Alert>
                    </div>
                    }
                    <div>
                        <UserListTable data={userList} isShowUserDetail={isShowUserDetail} status={status}
                                       openDetailPage={this.openDetailPage} onFresh={this.initDataList}
                                       maxHeight={containerHeight} selectedUserId={selectedUserId}/>
                    </div>
                </div>
                {isShowUserDetail && (
                    <div id="detailContainer" className='col-md-7 detailInfo'>
                        <UserDetail ref={(detail) => {this.userDetailPanel = detail}} {...this.props}
                                    close={this.closeDetailPage}/>
                    </div>
                )}
            </div>
        );
    }
}

export default UserListView;


// WEBPACK FOOTER //
// ./src/modules/user/UserListView.js